import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css, keyframes } from '@emotion/react';
import { useCallback } from 'react';
import { BOLD_FONT_FAMILY } from '../../constants/constants';
import { thunkHidePrizeWin } from '../../redux/actions/commonActions';
import { useAppDispatch } from '../../redux/store';
import { YELLOW_COLOR } from '../../styles/colors';
const BACKDROP_CSS = css `
  z-index: 200;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: absolute;
  user-select: none;
  background-color: rgba(0, 0, 0, 0.7);
  font-family: ${BOLD_FONT_FAMILY};
`;
const KEYFRAMES = keyframes `
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }
  15% {
    opacity: 1;
    transform: translateX(0);
  }
  70% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(+40px);
  }
  `;
const TEXT_CONTAINER_CSS = css `
  transform: translate(-50%, -50%);
  position: absolute;
  left: 50%;
  top: 50%;
  filter: drop-shadow(4px 4px 0 black);
`;
const MESSAGE_CSS = css `
  color: white;
  font-size: 32px;
`;
const PRIZE_DESCRIPTION_CSS = css `
  color: ${YELLOW_COLOR};
  font-size: 24px;
`;
export const PrizeWinDisplay = ({ message, prizeDescription, durationMs }) => {
    const dispatch = useAppDispatch();
    const onAnimationEnd = useCallback(() => {
        dispatch(thunkHidePrizeWin());
    }, [dispatch]);
    const animationContainerCss = css `
    width: 100%;
    height: 100%;
    position: absolute;
    animation: ${KEYFRAMES} ${durationMs}ms forwards;
  `;
    return (_jsx("div", { css: BACKDROP_CSS, "data-testid": 'prize-win-display', "aria-hidden": true, children: _jsx("div", { css: animationContainerCss, onAnimationEnd: onAnimationEnd, children: _jsxs("div", { css: TEXT_CONTAINER_CSS, children: [_jsx("div", { css: MESSAGE_CSS, children: message }), _jsx("div", { css: PRIZE_DESCRIPTION_CSS, children: prizeDescription })] }) }) }));
};
